// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"../../styles/variables.css\"","textDefault":"#808080","container":"_3ptDcixW_n777f1OeabvhK","formWrapper":"Geh2tnw4H50M5_LdsXUiG","title":"_3jg_5M1a1pGwOi7kbNY1Vr","buttons":"ebXgl5ZsbJdeU4gaulTMa","link":"_3t5B1jdqFO_2yXIhMWQQlD"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/PasswordReset/PasswordReset.mod.css
// module id = 600
// module chunks = 0